const { BASE_URL } = require("./client");

const GET_ALL_USERS = BASE_URL + "/userdetails";
const REPORT_UPLOADED = BASE_URL + "/report-uploaded";
const CONNECT_WITH_US = BASE_URL + "/api/connect/post";

export { GET_ALL_USERS, REPORT_UPLOADED, CONNECT_WITH_US };
